import Icon from '../components/Icon.vue'

Icon.register({"windows":{"width":1664,"height":1792,"paths":[{"d":"M682 1006v651l-682-94v-557h682zM682 263v659h-682v-565zM1664 1006v786l-907-125v-661h907zM1664 128v794h-907v-669z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/windows.js
// module id = 1047
// module chunks = 0